export default __webpack_public_path__ + "static/media/FrontEndDeveloper.950e27c0.png";